/**
 * @desc 导出管理列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.QueryConditionsOfMakeOutInvoice): Promise<BaseResponse<defs.ResultBean>> {
  return fetch({
    url: config.API_HOST + '/invoice/exportOpenInvoiceList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
